// extracted by mini-css-extract-plugin
export default {"root":"Badge_root__0RuPC","value":"Badge_value__JUSfs","dot":"Badge_dot__uaJOm","large":"Badge_large__3kV8w"};